import React from 'react'
import { connect } from 'react-redux'
import Component from '../common/Component'
import fieldGroups, { benefitLabels, metadatumFieldsDiffSet } from './criticalIllnessFields'
import publishingActions from '../../actions/BenefitsSetsExportPublishings'
import BenefitsSetExportShow from '../BenefitsSet/BenefitsSetExportShow'

export class CriticalIllnessBenefitsSetExportShow extends Component {
  static defaultFields = [
    'id',
    'vericred_id',
    'approval_state',
    'publish_state',
    'name',
    'audience',
    'source',
    'issuer_identifier',
    'issuer_name'
  ]

  render() {
    return (
      <BenefitsSetExportShow
        productLine="Critical Illness"
        benefitLabels={benefitLabels}
        metadatumFieldsDiffSet={metadatumFieldsDiffSet}
        defaultFields={CriticalIllnessBenefitsSetExportShow.defaultFields}
        benefitsSetUrl="/critical_illness_benefits"
        fieldGroups={fieldGroups}
        {...this.props}
      />
    )
  }
}

const mapStateToProps = (state) => {
  return {
    exportPublish: state.benefitsSetsExportPublishings.create
  }
}

const mapDispatchToProps = {
  createExportPublish: publishingActions.create.main,
  resetCreateExportPublish: publishingActions.create.reset
}

export default connect(mapStateToProps, mapDispatchToProps)(CriticalIllnessBenefitsSetExportShow)
